import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadoColor',
})
export class EstadoColorPipe implements PipeTransform {
  transform(estado: string): string {
    const estadoLower = estado.toLowerCase();

    if (estadoLower === 'pendiente') {
      return 'black';
    } else if (
      estadoLower === 'en proceso' ||
      estadoLower === 'en espera' ||
      estadoLower === 'en control de calidad'
    ) {
      return '#ffc107'; // Amarillo
    } else if (
      estadoLower === 'finalizada' ||
      estadoLower === 'listo para comercializar'
    ) {
      return '#28a745'; // Verde
    } else if (estadoLower === 'desechada' || estadoLower === 'cancelada') {
      return '#dc3545'; // Rojo
    }

    return 'inherit'; // Color por defecto si no coincide
  }
}
